export class Publication{

    title:string;
    conference_name:string;
    conference_url;
    authors_list:string[]
    arxiv_link:string;
    doi:string;
    bibtex:string;
    year:number;
    date:Date;
    tags:string[];
    ppt:string;
    type:string;
    image_url:string;
    has_award:boolean;
    award_name:string;
    poster:string;
    proj_id:string;
    abstract:string;
    isPublished:boolean;
    current_status:string;
}